import lottie from 'lottie-web';
import { loadFonts } from '@loaders/FontLoader';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  async preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
    await loadFonts();
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.assetsLoad();
    this.load.start();

    this.load.on(
      'progress',
      () => {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      () => {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    // Plugins
    this.load.plugin(
      'rexkawaseblurpipelineplugin',
      'assets/EndSceneAssets/rexkawaseblurpipelineplugin.min.js',
      true,
    );
    this.load.plugin(
      'rexquadimageplugin',
      'assets/GameSceneAssets/rexquadimageplugin.min.js',
      true,
    );

    // Audio
    this.load.audio('reward_reveal', 'assets/Audio/reward_reveal.mp3');
    this.load.audio('confettiaudio', 'assets/Audio/confetti.wav');
    this.load.audio('carddaudio', 'assets/Audio/card_drop.mp3');
    this.load.audio('cardhaudio', 'assets/Audio/card_hover.wav');
    this.load.audio('cardsaudio', 'assets/Audio/card_sweep.wav');
    this.load.audio('T1audio', 'assets/Audio/Tut-1.mp3');
    this.load.audio('T2audio', 'assets/Audio/Tut-2.mp3');
    this.load.audio('T3audio', 'assets/Audio/Tut-3.mp3');
    this.load.audio('T5audio', 'assets/Audio/Tut-5.mp3');
    this.load.audio('caudio', 'assets/Audio/correct.mp3');
    this.load.audio('waudio', 'assets/Audio/wrong.mp3');
    this.load.audio('cardp', 'assets/Audio/cardp.mp3');
    this.load.audio('bgMusic', 'assets/Audio/bgaudio.mp3');
    this.load.audio('video1audio', 'assets/Audio/video1audio.mp3');
    this.load.audio('video2audio', 'assets/Audio/video2audio.mp3');

    // Reward animations
    this.load.multiatlas(
      'rewardLight',
      'assets/anims/rewardAnims/rewardLightAnim.json',
      'assets/anims/rewardAnims/',
    );
    this.load.multiatlas(
      'baseCircle',
      'assets/anims/rewardAnims/baseCircleAnim.json',
      'assets/anims/rewardAnims/',
    );
    this.load.multiatlas(
      'glitter',
      'assets/anims/rewardAnims/glitterAnim.json',
      'assets/anims/rewardAnims/',
    );
    this.load.multiatlas(
      'basecircle',
      'assets/RewardAnimation/baseCircle/baseCircleAnim.json',
      'assets/RewardAnimation/baseCircle',
    );
    this.load.image('compass', 'assets/anims/rewardAnims/compass.png');

    // End scene
    this.load.multiatlas(
      'endConfetti',
      'assets/EndSceneAssets/confetti/confettiAnimNew.json',
      'assets/EndSceneAssets/confetti',
    );
    this.load.multiatlas(
      'spotlight',
      'assets/EndSceneAssets/spotlight/spotlightAnimNew.json',
      'assets/EndSceneAssets/spotlight',
    );
    this.load.image('gameOver', 'assets/EndSceneAssets/Game Over.png');
    this.load.image('youWon', 'assets/EndSceneAssets/You won.png');
    this.load.image('correctIcon', 'assets/EndSceneAssets/correctIcon.png');
    this.load.image('incorrectIcon', 'assets/EndSceneAssets/incorrectIcon.png');
    this.load.image('retryButton', 'assets/EndSceneAssets/Retry Button.png');
    this.load.image('hover_retryButton', 'assets/EndSceneAssets/hover_Retry Button.png');
    this.load.image('hintIconMini', 'assets/EndSceneAssets/endHint.png');
    this.load.image('nextButton', 'assets/EndSceneAssets/nextButton.png');
    this.load.image('hover_nextButton', 'assets/EndSceneAssets/hover_nextbutton.png');
    this.load.image('replayButton', 'assets/EndSceneAssets/replayButton.png');
    this.load.image('hover_replayButton', 'assets/EndSceneAssets/hover_replayButton.png');
    this.load.image('endScreenOverlay', 'assets/EndSceneAssets/end screen.png');
    this.load.image('okayButton', 'assets/EndSceneAssets/okaybutton.png');
    this.load.image('hover_okayButton', 'assets/EndSceneAssets/hover_okaybutton.png');
    this.load.image('disable_okayButton', 'assets/EndSceneAssets/disable_okaybutton.png');
    this.load.image('rewardEarned', 'assets/EndSceneAssets/Rewards earned!.png');
    this.load.image('rewardName', 'assets/EndSceneAssets/helmet.png');

    // Start scene
    this.load.image('play_button', 'assets/StartSceneAssets/play_button.png');
    this.load.image('gameName', 'assets/StartSceneAssets/gameName.png');
    this.load.image('play_button_on', 'assets/StartSceneAssets/play_button_on.png');
    this.load.image('sbg', 'assets/StartSceneAssets/sbg.png');
    this.load.image('rpath', 'assets/StartSceneAssets/rpath.png');
    this.load.image('rocket', 'assets/StartSceneAssets/rocket.png');

    // Game scene
    this.load.video('drivein', 'assets/GameSceneAssets/HYPERDRIVE_BEGINING.mp4');
    this.load.video('driveout', 'assets/GameSceneAssets/HYPERDRIVE_end.mp4');
    this.load.image('overlay', 'assets/GameSceneAssets/overlay.png');
    this.load.image('ship', 'assets/GameSceneAssets/ship.png');
    this.load.image('stick', 'assets/GameSceneAssets/stick.png');
    this.load.image('check', 'assets/GameSceneAssets/check.png');
    this.load.image('check_h', 'assets/GameSceneAssets/check_h.png');
    this.load.image('nextQ', 'assets/GameSceneAssets/nextQ.png');
    this.load.image('nextQh', 'assets/GameSceneAssets/nextQh.png');
    this.load.image('pushbutton', 'assets/GameSceneAssets/pushbutton.png');
    this.load.image('bg', 'assets/GameSceneAssets/bg.png');
    this.load.image('T1', 'assets/GameSceneAssets/T1.png');
    this.load.image('T2', 'assets/GameSceneAssets/T2.png');
    this.load.image('T3', 'assets/GameSceneAssets/T3.png');
    this.load.image('T4', 'assets/GameSceneAssets/T4.png');
    this.load.image('T5', 'assets/GameSceneAssets/T5.png');
    this.load.image('hand', 'assets/GameSceneAssets/hand.png');
    this.load.image('arrow', 'assets/GameSceneAssets/arrow.png');
    this.load.image('box', 'assets/GameSceneAssets/box.png');
    this.load.image('lightbar', 'assets/GameSceneAssets/lightbar.png');
    this.load.image('green', 'assets/GameSceneAssets/green.png');
    this.load.image('A1', 'assets/GameSceneAssets/A1.png');

    // Dynamic image loops (originally in StartScene.create())
    for (let i = 0; i <= 6; i++) {
      for (let k = 1; k <= 6; k++) {
        this.load.image(
          'A_' + k + '_' + (i + 1),
          'assets/GameSceneAssets/A_' + k + '_' + (i + 1) + '.png',
        );
      }
      this.load.image('L' + i, 'assets/GameSceneAssets/L' + i + '.png');
      for (let j = -1; j <= 9; j++) {
        this.load.image(j + '_' + i, 'assets/GameSceneAssets/' + j + '_' + i + '.png');
      }
    }

    // Dynamic image loops (originally in GameScene.preload())
    for (let i = 1; i <= 5; i++) {
      for (let j = -1; j <= 9; j++) {
        this.load.image(
          j + '_' + i + 'c',
          'assets/GameSceneAssets/' + j + '_' + i + 'c.png',
        );
        this.load.image(
          j + '_' + i + 'w',
          'assets/GameSceneAssets/' + j + '_' + i + 'w.png',
        );
      }
    }

    // Hint scene
    this.load.atlas(
      'hintFinalAnim',
      'assets/HintSceneAssets/hintFinalAnim.png',
      'assets/HintSceneAssets/hintFinalAnim.json',
    );
    this.load.image('hintClose', 'assets/HintSceneAssets/closeHint.png');
    this.load.image('hintText', 'assets/HintSceneAssets/hintText.png');
    this.load.image('hintText2', 'assets/HintSceneAssets/hintText2.png');
  }
}
